// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SwitchSite_wrapper__1DEdc bodySDefault"};